import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import { TEMAS, MODULOS, cargarApariencia } from "../utils/temas";
import { Ayuda } from "../context/AyudaContext";

// El administrador elige el tema y en qué módulos se aplica. Los módulos sin marcar conservan el Institucional.
function GestionarApariencia() {
  const [tema, setTema] = useState("institucional");
  const [modulos, setModulos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    apiFetch("/api/apariencia")
      .then((d) => {
        setTema(d.tema);
        setModulos(d.modulos);
      })
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  }, []);

  const alternar = (clave) =>
    setModulos((prev) => (prev.includes(clave) ? prev.filter((m) => m !== clave) : [...prev, clave]));

  const guardar = async () => {
    setGuardando(true);
    setMensaje("");
    setError("");
    try {
      const r = await apiFetch("/api/apariencia", { method: "POST", body: JSON.stringify({ tema, modulos }) });
      setMensaje(r?.message || "Apariencia guardada.");
      cargarApariencia(); // para que el cambio se vea sin recargar
    } catch (err) {
      setError(err.message);
    } finally {
      setGuardando(false);
    }
  };

  if (cargando) return null;

  return (
    <div style={estilos.tarjeta}>
      <h3 style={{ margin: "0 0 0.2rem", color: "#0b3c60" }}>🎨 Apariencia</h3>
      <Ayuda>
      <p style={estilos.ayuda}>Elige el tema de color para todos los usuarios y en qué módulos se aplica.</p>
      </Ayuda>

      <div style={estilos.temas}>
        {TEMAS.map((t) => {
          const elegido = tema === t.clave;
          return (
            <button
              key={t.clave}
              type="button"
              aria-pressed={elegido}
              onClick={() => setTema(t.clave)}
              style={{ ...estilos.tema, ...(elegido ? estilos.temaElegido : {}) }}
            >
              {/* Vista previa: franja, línea de acento y encabezado de tabla con los colores del tema. */}
              <div style={{ background: t.colores.franja, borderBottom: `3px solid ${t.colores.acento}`, color: t.colores.franjaTexto, ...estilos.previaFranja }}>
                Gestión de Compras
              </div>
              <div style={{ background: t.colores.primario, ...estilos.previaTabla }} />
              <div style={estilos.temaNombre}>
                {elegido ? "✓ " : ""}
                {t.nombre}
              </div>
              <div style={estilos.temaDescripcion}>{t.descripcion}</div>
            </button>
          );
        })}
      </div>

      <div style={estilos.encabezadoModulos}>
        <strong style={{ color: "#0b3c60", fontSize: "0.88rem" }}>Aplicar en:</strong>
        <button type="button" onClick={() => setModulos(MODULOS.map((m) => m.clave))} style={estilos.botonSecundario}>
          Todos
        </button>
        <button type="button" onClick={() => setModulos([])} style={estilos.botonSecundario}>
          Ninguno
        </button>
      </div>
      <div style={estilos.modulos}>
        {MODULOS.map((m) => (
          <label key={m.clave} style={estilos.modulo}>
            <input type="checkbox" checked={modulos.includes(m.clave)} onChange={() => alternar(m.clave)} />
            {m.nombre}
          </label>
        ))}
      </div>
      <Ayuda>
      <p style={estilos.ayuda}>Los módulos sin marcar se quedan con el tema Institucional.</p>
      </Ayuda>

      {error && <p style={{ color: "#a3402f", margin: "0.4rem 0" }}>{error}</p>}
      {mensaje && <p style={{ color: "#2f7a54", fontWeight: 600, margin: "0.4rem 0" }}>✓ {mensaje}</p>}

      <button type="button" disabled={guardando} onClick={guardar} style={estilos.botonPrincipal}>
        {guardando ? "Guardando..." : "💾 Guardar apariencia"}
      </button>
    </div>
  );
}

const estilos = {
  tarjeta: { background: "#fff", border: "1px solid #e2e6ea", borderRadius: 14, padding: "1.1rem 1.2rem", marginBottom: "1.2rem", boxShadow: "0 1px 3px rgba(27,42,74,0.06)" },
  ayuda: { margin: "0 0 0.8rem", color: "#5b6472", fontSize: "0.82rem" },
  temas: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))", gap: "0.7rem", marginBottom: "1rem" },
  tema: { border: "2px solid #e2e6ea", borderRadius: 12, padding: "0.5rem", background: "#fff", cursor: "pointer", textAlign: "left", fontFamily: "inherit" },
  temaElegido: { borderColor: "#2f7a54", boxShadow: "0 0 0 2px #dcf0e6" },
  previaFranja: { borderRadius: "7px 7px 0 0", padding: "0.5rem 0.6rem", fontSize: "0.76rem", fontWeight: 700 },
  previaTabla: { height: 12, marginBottom: "0.45rem" },
  temaNombre: { fontWeight: 700, color: "#0b3c60", fontSize: "0.88rem" },
  temaDescripcion: { color: "#5b6472", fontSize: "0.76rem", marginTop: "0.1rem" },
  encabezadoModulos: { display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.5rem" },
  modulos: { display: "flex", gap: "0.5rem 1.2rem", flexWrap: "wrap", marginBottom: "0.6rem" },
  modulo: { display: "inline-flex", alignItems: "center", gap: "0.4rem", fontSize: "0.88rem", color: "#0b3c60", cursor: "pointer" },
  botonPrincipal: { background: "#0b3c60", color: "#fff", border: "none", borderRadius: 8, padding: "0.55rem 1.1rem", fontSize: "0.88rem", fontWeight: 700, cursor: "pointer" },
  botonSecundario: { background: "#fff", color: "#0b3c60", border: "1px solid #d3d9df", borderRadius: 8, padding: "0.3rem 0.7rem", fontSize: "0.78rem", fontWeight: 600, cursor: "pointer" },
};

export default GestionarApariencia;
